






















import { Vue, Component, Prop } from 'vue-property-decorator';
import utils from '@/services/utils';

@Component
export default class LogBody extends Vue {
  @Prop() readonly data!: object;

  @Prop() readonly handleSub!: Function;

  utilsInstance = utils;
}
